export default {
  namespaced: true,
  state: {
    authenticated: false
  },
  getters: {},
  mutations: {},
  actions: {
    logout () {

    },
    login () {

    }
  }
}
